import React from 'react';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Wrapper = styled.div.withConfig({
  componentId: "sc-kha42e-0"
})(["display:flex;flex-direction:column;min-height:", ";"], SIZES[52]);
const Container = styled.div.withConfig({
  componentId: "sc-kha42e-1"
})(["display:flex;align-items:flex-end;padding:", " ", ";"], SIZES['8'], SIZES['16']);
const StackText = styled.div.withConfig({
  componentId: "sc-kha42e-2"
})(["display:flex;flex-direction:column;justify-content:space-between;flex:1;overflow:hidden;white-space:nowrap;"]);
const Subject = styled(Typography).withConfig({
  componentId: "sc-kha42e-3"
})(["&&&{color:", ";}"], COLORS.darkestGrey);
const Line = styled.span.withConfig({
  componentId: "sc-kha42e-4"
})(["margin:0 ", ";width:auto;border-bottom:", " solid ", ";"], SIZES['16'], SIZES['1'], COLORS.lighterGrey);
export default function ActivityHeader(_ref) {
  let {
    children,
    title,
    subject,
    publishDate
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "ActivityHeader",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, children, /*#__PURE__*/React.createElement(StackText, {
    "data-sentry-element": "StackText",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption3",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, title), /*#__PURE__*/React.createElement(Subject, {
    variant: "caption3",
    "data-sentry-element": "Subject",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, subject)), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption3",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }, publishDate)), /*#__PURE__*/React.createElement(Line, {
    "data-sentry-element": "Line",
    "data-sentry-source-file": "ActivityHeader.tsx"
  }));
}